/* eslint-disable */
import React, { useState, useEffect } from 'react';
import './DssColumnSelectionModal.css';

const ColumnSelector = ({ columns, selectedColumns, onColumnChange }) => {
    const [localSelectedColumns, setLocalSelectedColumns] = useState([]);

    // console.log("Test data columnselector ------------>", columns);

    useEffect(() => {
        if (columns.length > 0) {
            setLocalSelectedColumns(selectedColumns);
        }
    }, [columns, selectedColumns]);

    const handleCheckboxChange = (accessor) => {
        const newSelectedColumns = localSelectedColumns.includes(accessor)
            ? localSelectedColumns.filter(col => col !== accessor)
            : [...localSelectedColumns, accessor];
        setLocalSelectedColumns(newSelectedColumns);
    };

    const handleSelectAll = () => {
        if (localSelectedColumns.length === columns.length) {
            setLocalSelectedColumns([]);
        } else {
            setLocalSelectedColumns(columns.map(col => col.accessor));
        }
    };

    const handleSubmit = () => {
        onColumnChange(localSelectedColumns);
    };

    if (columns.length === 0) {
        return null;
    }

    return (
        <div className="column-selector">
            <span className='title-name'>CUSTOMIZE COLUMNS</span>
            <div className="selector">
                <label>
                    <input
                        type="checkbox"
                        checked={localSelectedColumns.length === columns.length}
                        onChange={handleSelectAll}
                    />
                    Select All
                </label>
                {columns.map(col => (
                    <label key={col.accessor}>
                        <input
                            type="checkbox"
                            checked={localSelectedColumns.includes(col.accessor)}
                            onChange={() => handleCheckboxChange(col.accessor)}
                        />
                        {col.header}
                    </label>
                ))}
            </div>
            <button onClick={handleSubmit} style={{backgroundColor:"#6AA98F", marginLeft:"87%"}} className="submit-button">SAVE</button>
        </div>
    );
};

export default ColumnSelector;